<template>
	<q-page padding>
		<div class="q-display-1 q-mb-md text-secondary">
			<q-icon name="fas fa-ad" class="q-mb-sm" /> {{ $t('banner') }}
		</div>

		<div class="row gutter-sm q-mb-lg">
			<div class="col-xs-12 col-sm-12">
				<q-input v-model="title" ref="title" :float-label="$t('title')" :error="$v.title.$error"
					@input="$v.title.$touch" />
			</div>

			<div class="col-xs-12 col-sm-8">
				<q-select v-model="banner_type" ref="banner_type" :options="bannerTypes"
					:float-label="$t('banner_type')" :error="$v.banner_type.$error" @input="$v.banner_type.$touch" />
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-select v-model="use_token" ref="use_token" :options="use_tokens"
					:float-label="$t('use_token_on_url')" />
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-field :helper="$t('no_www_starting_with_http_https')">
					<q-input v-model="url" ref="url" :float-label="$t('url')" :error="$v.url.$error"
						@input="$v.url.$touch" />
				</q-field>
			</div>
			<div class="col-xs-12 col-sm-12 ">
				<div class="row gutter-sm flex">
					<div class="col-xs-12 col-sm-6">
						<p class="caption">
							<a href="assets/banner-template-desktop.png" target="_blank">
								<q-icon name="far fa-images" /></a>
							{{ $t('desktop_banner') }}
						</p>
						<uploader content_type="images" @fileUploaded="imageUploadedDesktop" :multiple="false"
							:cropper="true" :aspect_ratio="1600 / 340" :aspect_ratio_string="'1600/340'"
							:error="$v.image_desktop.$error" @input="$v.image_desktop.$touch" />

						<p v-if="image_desktop" ref="image_desktop" class="q-mt-md file-url">
							<q-icon name="fas fa-check" color="positive" />
							<a :href="image_desktop" target="_blank">
								{{ $truncateLink(image_desktop) }}</a>
						</p>
					</div>
					<div class="col-xs-12 col-sm-6">
						<p class="caption">
							{{ $t('alt_image') }}
							<q-icon name="far fa-question-circle" size="1.5rem" color="grey" class="q-ml-sm q-pb-sm">
								<q-tooltip class="custom-tooltip" anchor="top left" self="bottom right">
									{{ $t('alt_image_information_helper') }}
								</q-tooltip>
							</q-icon>
						</p>
						<div class="flex justify-between">
							<template v-for="lang in languages" class="row flex">
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'pt-br'">
									<q-input v-model="language_br_desktop" :float-label="$t(`${lang.name}`)"
										ref="language_br_desktop" :error="$v.language_br_desktop.$error"
										@input="$v.language_br_desktop.$touch" />
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'en-us'">
									<q-input v-model="language_us_desktop" :float-label="$t(`${lang.name}`)"
										ref="language_us_desktop" :error="$v.language_us_desktop.$error"
										@input="$v.language_us_desktop.$touch" />
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'es-es'">
									<q-input v-model="language_es_desktop" :float-label="$t(`${lang.name}`)"
										ref="language_es_desktop" :error="$v.language_es_desktop.$error"
										@input="$v.language_es_desktop.$touch" />
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'fr-fr'">
									<q-input v-model="language_fr_desktop" :float-label="$t(`${lang.name}`)"
										ref="language_fr_desktop" :error="$v.language_fr_desktop.$error"
										@input="$v.language_fr_desktop.$touch" />
								</q-field>
							</template>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-sm-12 ">
				<div class="row gutter-sm flex">
					<div class="col-xs-12 col-sm-6">
						<p class="caption">
							<a href="assets/banner-template-mobile.png" target="_blank">
								<q-icon name="far fa-images" /></a>
							{{ $t('mobile_banner') }}
						</p>
						<uploader content_type="images" @fileUploaded="imageUploadedMobile" :multiple="false"
							:cropper="true" :aspect_ratio="600 / 317" :aspect_ratio_string="'600/317'"
							:error="$v.image_mobile.$error" @input="$v.image_mobile.$touch" />
						<p v-if="image_mobile" ref="image_mobile" class="q-mt-md file-url">
							<q-icon name="fas fa-check" color="positive" />
							<a :href="image_mobile" target="_blank">
								{{ $truncateLink(image_mobile) }}</a>
						</p>
					</div>
					<div class="col-xs-12 col-sm-6">
						<p class="caption">
							{{ $t('alt_image') }}
							<q-icon name="far fa-question-circle" size="1.5rem" color="grey" class="q-ml-sm q-pb-sm">
								<q-tooltip class="custom-tooltip" anchor="top left" self="bottom right">
									{{ $t('alt_image_information_helper') }}
								</q-tooltip>
							</q-icon>
						</p>
						<div class="flex justify-between">
							<template v-for="lang in languages" class="row flex">
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'pt-br'">
									<q-input v-model="language_br_mobile" :float-label="$t(`${lang.name}`)"
										ref="language_br_mobile" :error="$v.language_br_desktop.$error"
										@input="$v.language_br_desktop.$touch" />
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'en-us'">
									<q-input v-model="language_us_mobile" :float-label="$t(`${lang.name}`)"
										ref="language_us_mobile" :error="$v.language_us_desktop.$error"
										@input="$v.language_us_desktop.$touch" />
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'es-es'">
									<q-input v-model="language_es_mobile" :float-label="$t(`${lang.name}`)"
										ref="language_es_mobile" :error="$v.language_es_desktop.$error"
										@input="$v.language_es_desktop.$touch" />
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'fr-fr'">
									<q-input v-model="language_fr_mobile" :float-label="$t(`${lang.name}`)"
										ref="language_fr_mobile" :error="$v.language_fr_desktop.$error"
										@input="$v.language_fr_desktop.$touch" />
								</q-field>
							</template>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12">
				<q-select v-model="timezone" ref="timezone" :options="timezones" :float-label="$t('timezone')" filter
					:error="$v.timezone.$error" @input="$v.timezone.$touch" />
			</div>
			<div class="col-xs-12 col-sm-6">
				<q-datetime v-model="start_date" ref="start_date" type="datetime" :float-label="$t('publish_date')"
					format="DD/MM/YYYY HH:mm" clearable />
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-datetime v-model="end_date" ref="end_date" type="datetime" :float-label="$t('end_date')"
					format="DD/MM/YYYY HH:mm" clearable />
			</div>
		</div>

		<q-tabs v-model="tab" color="secondary" class="shadow-1">
			<q-tab slot="title" name="permissions" icon="fas fa-clipboard-check"
				:label="$t('areas_and_profiles')" />

			<q-tab-pane name="permissions" class="q-px-lg q-pb-xl">
				<div class="row gutter-sm">
					<div class="col-xs-12 col-sm-12">
						<p class="caption">{{ $t('areas') }}</p>
						<q-checkbox class="q-mb-sm" v-model="all_areas" :val="true" :label="$t('select_all_areas')"
							@input="checkAllAreas()" />
						<select-multiple :filters="area" :options="areas" :error="$v.area.$error"
							:input="$v.area.$touch" @on_value="area = $event" />
					</div>

					<div class="col-xs-12 col-sm-12">
						<p class="caption">{{ $t('profiles') }}</p>

						<div class="row gutter-sm">
							<div class="col-xs-12 col-sm-12">
								<q-checkbox v-model="all_profiles" :val="true" :label="$t('all')" @input="checkAll()" />
							</div>

							<div class="col-xs-12 col-sm-4" v-for="(item, index) in profiles" :key="index"
								:class="getErrorClass($v.profile.$error)">
								<q-checkbox keep-color v-model="profile" ref="profile" :val="item.value"
									:label="item.label" @input="$v.profile.$touch"
									:color="getErrorColor($v.profile.$error)" />
							</div>
							<div class="col-xs-12 col-sm-12">
								<q-select v-model="user_group" ref="user_group" :options="user_groups"
									:float-label="$t('groups')" :error="$v.user_group.$error"
									@input="$v.user_group.$touch" multiple chips />
							</div>
						</div>
					</div>
				</div>
			</q-tab-pane>
		</q-tabs>

		<div class="row gutter-sm q-mt-md">
			<div class="col-xs-12 col-sm-12">
				<p class="caption">{{ $t('status') }}</p>
				<q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses" />
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-chevron-left"
					@click="$router.push({ name: 'admin_banners' })" />
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')" v-if="showDuplicateButton">
				<q-btn color="info" class="full-width" :label="$t('duplicate')" icon="far fa-copy"
					@click="show_duplicate_modal = true" />
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save"
					@click="saveData()" />
			</div>
		</div>

		<duplicate :show="show_duplicate_modal" @hideDuplicate="hideDuplicate" />
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, url, maxLength } from 'vuelidate/lib/validators'
import { date } from 'quasar'
import Uploader from 'components/Uploader'
import Duplicate from './Duplicate'
import * as moment from 'moment'
import * as tz from 'moment-timezone'
import SelectMultiple from 'components/utils/SelectMultiple'
export default {
	i18nOptions: { namespaces: ['custom', 'common', 'banners', 'admin'] },

	components: {
		uploader: Uploader,
		duplicate: Duplicate,
		'select-multiple': SelectMultiple,
	},

	data() {
		return {
			language_br_desktop: '',
			language_us_desktop: '',
			language_es_desktop: '',
			language_fr_desktop: '',
			language_br_mobile: '',
			language_us_mobile: '',
			language_es_mobile: '',
			language_fr_mobile: '',
			id: '',
			title: '',
			banner_type: '',
			url: null,
			status: 1,
			start_date: '',
			end_date: '',
			timezone: '',
			statuses: [
				{
					label: this.$t('published'),
					value: 1,
				},
				{
					label: this.$t('unpublished'),
					value: 2,
				},
			],
			area: [],
			profile: [],
			user_group: [],
			all_profiles: false,
			tab: 'permissions',
			image_desktop: '',
			image_mobile: '',
			all_areas: false,
			show_duplicate_modal: false,
			use_token: false,
			use_tokens: [
				{ label: this.$t('yes'), value: true },
				{ label: this.$t('no'), value: false },
			],
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			faq_categories: 'registration_lists/faq_categories',
			areas: 'registration_lists/country_areas',
			user_groups: 'registration_lists/group_users',
			banner_types: 'registration_lists/banner_types',
			profiles: 'registration_lists/profiles',
			id_user_client_selected: 'common/id_user_client_selected',
			clients: 'params/clients',
			login_use_portfolio_page: 'params/login_use_portfolio_page',
			timezones: 'registration_lists/timezones',
			languages: 'params/languages',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getColorStatus() {
			if (this.status == 1) return 'positive'
			else return 'negative'
		},

		selectedClientModules() {
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj) return obj
			else return {}
		},

		bannerTypes() {
			return this.banner_types
				.filter((e) => {
					switch (e.label) {
						case 'trainings':
							return this.selectedClientModules.has_courses
						case 'trails':
							return this.selectedClientModules.has_trails
						case 'webinars':
							return this.selectedClientModules.has_webcasts
						case 'home':
							return this.selectedClientModules.has_home
						case 'portfolio':
							return this.login_use_portfolio_page
						case 'podcasts':
							return this.selectedClientModules.has_podcasts
						case 'live_classes':
							return this.selectedClientModules.has_live_classes
						case 'library_files':
							return this.selectedClientModules.has_library
						case 'news':
							return this.selectedClientModules.has_news
						case 'presential':
							return this.selectedClientModules.has_presential
						default:
							return true
					}
				})
				.map((e) => ({
					...e,
					label: this.$t(e.label),
				}))
		},

		showDuplicateButton() {
			if (this.$route.params.id != 0) return true
			else return false
		},
	},

	methods: {
		imageUploadedDesktop(url, item, urlSigned) {
			if (url) this.image_desktop = urlSigned
		},
		imageUploadedMobile(url, item, urlSigned) {
			if (url) this.image_mobile = urlSigned
		},
		saveData() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()
				let data = {
					title: this.title,
					banner_type: this.banner_type,
					status: this.status,
					image_desktop: this.image_desktop.split('?')[0],
					use_token: this.use_token,
				}

				this.timezone ? (data.timezone = this.timezone) : (data.timezone = null)

				this.start_date
					? (data.start_date = moment(
						date.formatDate(this.start_date, 'YYYY-MM-DDTHH:mm')
					)
						.tz(this.timezone, true)
						.format('YYYY-MM-DDTHH:mm:ssZ'))
					: (data.start_date = null)

				this.end_date
					? (data.end_date = moment(date.formatDate(this.end_date, 'YYYY-MM-DDTHH:mm'))
						.tz(this.timezone, true)
						.format('YYYY-MM-DDTHH:mm:ssZ'))
					: (data.end_date = null)

				data.image_mobile = this.image_mobile.split('?')[0]

				if (this.url !== null && this.url !== '') data.url = this.url
				else data.url = null

				if (this.area.length > 0 && this.profile.length > 0) {
					data.areas = this.area
					data.profiles = this.profile
				}

				if (this.user_group.length > 0) data.user_groups = this.user_group

				data.banner_image_alt_texts = [
					{
						alt_text: this.language_br_desktop || '',
						image_type: 1,
						language: 'pt-br',
					},
					{
						alt_text: this.language_us_desktop || '',
						image_type: 1,
						language: 'en-us',
					},
					{
						alt_text: this.language_es_desktop || '',
						image_type: 1,
						language: 'es-es',
					},
					{
						alt_text: this.language_fr_desktop || '',
						image_type: 1,
						language: 'fr-fr',
					},
					{
						alt_text: this.language_br_mobile || '',
						image_type: 2,
						language: 'pt-br',
					},
					{
						alt_text: this.language_us_mobile || '',
						image_type: 2,
						language: 'en-us',
					},
					{
						alt_text: this.language_es_mobile || '',
						image_type: 2,
						language: 'es-es',
					},
					{
						alt_text: this.language_fr_mobile || '',
						image_type: 2,
						language: 'fr-fr',
					},
				]

				if (this.id != 0) {
					this.$axios
						.put(`/admin_banners/banners/${this.id}/`, data, this.getHeader)
						.then((response) => {
							this.$q.loading.hide()

							this.$q.notify({
								message: this.$t('banner_edit_success'),
								type: 'positive',
								icon: 'far fa-save',
							})

							this.$router.push({ name: 'admin_banners' })
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				} else {
					this.$axios
						.post(`/admin_banners/banners/`, data, this.getHeader)
						.then((response) => {
							this.$q.loading.hide()
							this.$q.notify({
								message: this.$t('banner_add_success'),
								type: 'positive',
								icon: 'far fa-save',
							})

							this.$router.push({ name: 'admin_banners' })
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				}
			} else {
				this.$formInputErrorFocus(this.$v, this.$refs)
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fas fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(`/admin_banners/banners/${this.id}/`, this.getHeader)
				.then((response) => {
					this.title = response.data.title
					this.banner_type = response.data.banner_type
					this.image_desktop = response.data.image_desktop
					this.image_mobile = response.data.image_mobile
					this.profile = response.data.profiles
					this.area = response.data.areas
					this.user_group = response.data.user_groups
					this.status = response.data.status
					this.url = response.data.url
					this.use_token = response.data.use_token
					const altTexts = response.data.banner_image_alt_texts || []
					const altTextsMap = altTexts.reduce((result, altTextObj) => {
						const { alt_text, image_type, language } = altTextObj
						const altTextKey = `language_${language.replace(/-/g, '_')}_${image_type === 1 ? 'desktop' : 'mobile'
							}`
						result[altTextKey] = alt_text || ''
						return result
					}, {})

					this.language_br_desktop = altTextsMap.language_pt_br_desktop
						? altTextsMap.language_pt_br_desktop
						: ''

					this.language_br_mobile = altTextsMap.language_pt_br_mobile
						? altTextsMap.language_pt_br_mobile
						: ''

					this.language_es_desktop = altTextsMap.language_es_es_desktop
						? altTextsMap.language_es_es_desktop
						: ''

					this.language_es_mobile = altTextsMap.language_es_es_mobile
						? altTextsMap.language_es_es_mobile
						: ''

					this.language_fr_desktop = altTextsMap.language_fr_fr_desktop
						? altTextsMap.language_fr_fr_desktop
						: ''

					this.language_fr_mobile = altTextsMap.language_fr_fr_mobile
						? altTextsMap.language_fr_fr_mobile
						: ''

					this.language_us_desktop = altTextsMap.language_en_us_desktop
						? altTextsMap.language_en_us_desktop
						: ''

					this.language_us_mobile = altTextsMap.language_en_us_mobile
						? altTextsMap.language_pt_br_mobile
						: ''

					if (response.data.timezone) this.timezone = response.data.timezone
					if (response.data.start_date) this.start_date = response.data.start_date
					if (response.data.end_date) this.end_date = response.data.end_date

					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		getErrorColor(state) {
			if (state) return 'negative'
			else return ''
		},

		getErrorClass(state) {
			if (state) return 'checkbox-error'
			else return ''
		},

		checkAll() {
			if (this.all_profiles) {
				this.profiles.forEach((element) => {
					this.profile.push(element.value)
				})
			} else {
				this.profile = []
			}
		},

		checkAllAreas() {
			if (this.all_areas) {
				this.area = this.areas.map((e) => e.value)
			} else {
				this.area = []
			}
		},

		hideDuplicate() {
			this.show_duplicate_modal = false
		},

		fetchTimezones() {
			let values = []

			moment.tz
				.names()
				.reduce((memo, tz) => {
					memo.push({
						name: tz,
						offset: moment.tz(tz).utcOffset(),
					})

					return memo
				}, [])
				.sort((a, b) => {
					return a.offset - b.offset
				})
				.reduce((memo, tz) => {
					const timezone = tz.offset ? moment.tz(tz.name).format('Z') : ''
					values.push({ value: tz.name, label: `(GMT${timezone}) ${tz.name}`, ...tz })
				}, '')

			this.$store.dispatch('registration_lists/SET_TIMEZONES', [values])
		},
	},

	created() {
		this.fetchTimezones()
		this.id = this.$route.params.id

		if (this.id != 0) this.fetchData()
	},

	validations() {
		return {
			title: { required },
			language_br_desktop: { maxLength: maxLength(256) },
			language_us_desktop: { maxLength: maxLength(256) },
			language_es_desktop: { maxLength: maxLength(256) },
			language_fr_desktop: { maxLength: maxLength(256) },
			banner_type: { required },
			image_desktop: { required },
			image_mobile: { required },
			url: { url },
			area: {
				requiredIf: requiredIf(() => {
					if (this.profile.length == 0 && this.area.length == 0) {
						if (
							this.profile.length == 0 &&
							this.area.length == 0 &&
							this.user_group.length == 0
						)
							return true
						else return false
					} else {
						return true
					}
				}),
			},

			timezone: {
				requiredIf: requiredIf(() => {
					if (this.start_date || this.end_date) return true
					else return false
				}),
			},

			profile: {
				requiredIf: requiredIf(() => {
					if (this.profile.length == 0 && this.area.length == 0) {
						if (
							this.profile.length == 0 &&
							this.area.length == 0 &&
							this.user_group.length == 0
						)
							return true
						else return false
					} else {
						return true
					}
				}),
			},
			user_group: {
				requiredIf: requiredIf(() => {
					if (
						this.profile.length == 0 &&
						this.area.length == 0 &&
						this.user_group.length == 0
					) {
						return true
					} else {
						return false
					}
				}),
			},
		}
	},
}
</script>

<style lang="stylus" scoped>
@import '~variables'
a
    text-decoration none
    color black
</style>
